<template>
  <div>
    <!-- Se agrega nuevo div Para boton! Obtener Ordenes - Pablo 10-05-21 -->
    <div class="bg-info clearfix">
      <vx-tooltip
        text="¿No ves tus órdenes? Deberás hacer clic en ‘Obtener órdenes’ para ver las órdenes nuevas. "
        class="float-left"
      >
        <vs-icon
          class="mb-5"
          icon="live_help"
          size="45px"
          color="#21094e"
        ></vs-icon>
      </vx-tooltip>

      <vs-button
        color="rgb(13, 168, 205)"
        class="float-right mb-3"
        type="filled"
        :disabled="loading"
        @click="getNewOrders()"
        ><span>
          <vs-icon
            class="float-left mr-3"
            icon="update"
            size="24px"
            color="#fff"
          >
          </vs-icon>Obtener órdenes</span
        ></vs-button
      >
    </div>
    <div class="flex flex-row justify-between">
      <div
        class="w-full mx-2"
        :key="status.key"
        v-for="status in ordersStatuses"
      >
        <order-status-card
          :status="status.name"
          :count="status.count"
          :url="status.url"
          :icon="status.icon"
          :loading="status.loading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OrderStatusCard from "@/components/OrderStatusCard.vue";
import axios from "axios";

export default {
  data() {
    return {
      loading: false,
      ordersStatuses: [
        {
          key: "nToProcess",
          name: "Por enviar",
          count: 0,
          url: "/ordenes/por-enviar",
          icon: "InboxIcon",
          loading: true,
        },
        {
          key: "nProcessed",
          name: "Procesadas",
          count: 0,
          url: "/ordenes/procesadas",
          icon: "FastForwardIcon",
          loading: true,
        },
        {
          key: "nInvalid",
          name: "Invalidas",
          count: 0,
          url: "/ordenes/invalidas",
          icon: "XIcon",
          loading: true,
        },
        {
          key: "nArchived",
          name: "Desestimadas",
          count: 0,
          url: "/ordenes/desestimadas",
          icon: "XCircleIcon",
          loading: true,
        },
      ],
    };
  },
  components: {
    OrderStatusCard,
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      let vm = this;
      // Load counts for all other statues
      axios
        .get(process.env.VUE_APP_BACKEND_URL + "api/orders-status-count")
        .then((resp) => vm.populateCards(resp), setTimeout(() => {
          this.loading = false
        }, 1000))
        .catch((error) => {
          console.log(error);
        });

      // Load count for "pending"  -
      //Se Saco este llamado ya que ahora carga los count directo de la BD - 10-05-21 Pablo
      // axios
      //   .get(
      //     process.env.VUE_APP_BACKEND_URL + "api/orders-status-count/pending"
      //   )
      //   .then((resp) => vm.populateCards(resp))
      //   .catch((error) => {
      //     console.log(error);
      //   });
    },
    getNewOrders() {
      this.loading = true
      axios
        .get(process.env.VUE_APP_BACKEND_URL + "api/getNewOrders")
        .then(() => this.loadData(), this.randomCenter())
        .catch((error) => {
          console.log(error);
        });
    },
    randomCenter() {
      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      }
      let color = `rgb(92,184,92)`;
      this.$vs.notify({
        title: "Órdenes",
        text: "Órdenes Obtenidas Correctamente",
        color: color,
        position: "top-center",
      });
    },

    populateCards(resp) {
      if (resp && resp.data && Array.isArray(resp.data)) {
        resp.data.forEach((order) => {
          this.ordersStatuses.forEach((orderStatus) => {
            if (order.key === orderStatus.key) {
              orderStatus.count = order.count;
              orderStatus.loading = false;
            }
          });
        });
      }
    },
  },
};
</script>
